import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {Row, Col, Input, Button, ButtonToolbar} from 'react-bootstrap'
import cx from 'classnames'
import {errorStatus} from '../../core/redux/status'
import {connectForm, integerField} from '../../core/redux/form'
import distance from '../../core/distance'
import extract, {replace} from '../../core/extract'
import Icon from '../../core/components/Icon'
import config from '../../config'
import {DEFINE_CALL_OUT_CHARGES_FOR_INTERVENTION_PERIOD_CMD_UPDATED, sendDefineCallOutChargesForInterventionPeriodCmd, sendRemoveCallOutChargesFromInterventionPeriodCmd, updateDefineCallOutChargesForInterventionPeriodCmd, loadProvider} from '../actions'
import {DefineCallOutChargesForInterventionPeriodCmd} from '../models'
import i18n from '../i18n'
import style from './DefineRemoveCallOutChargesFromInterventionPeriodForm.less'

function defineCmdUpdate(interventionPeriod) {
    return {
        callOutCharges: interventionPeriod.callOutCharges
    }
}

class DefineRemoveCallOutChargesFromInterventionPeriodForm extends Component {
    static propTypes = {
        activity: PropTypes.object.isRequired,
        interventionPeriod: PropTypes.object.isRequired,
        onSubmit: PropTypes.func.isRequired
    }

    componentWillMount() {
        const {dispatch, interventionPeriod} = this.props

        const update = defineCmdUpdate(interventionPeriod)
        dispatch(updateDefineCallOutChargesForInterventionPeriodCmd(update))
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.interventionPeriod != this.props.interventionPeriod) {
            const {dispatch, interventionPeriod} = nextProps

            const update = defineCmdUpdate(interventionPeriod)
            dispatch(updateDefineCallOutChargesForInterventionPeriodCmd(update))
        }
    }

    _sendDefineCmd() {
        const {dispatch, activity, interventionPeriod, onSubmit} = this.props

        return dispatch(sendDefineCallOutChargesForInterventionPeriodCmd(activity.uid, interventionPeriod.uid)).then(() => {
            return dispatch(loadProvider())
        }).then(() => {
            onSubmit()
        })
    }

    _sendRemoveCmd() {
        const {dispatch, activity, interventionPeriod, onSubmit} = this.props

        return dispatch(sendRemoveCallOutChargesFromInterventionPeriodCmd(activity.uid, interventionPeriod.uid)).then(() => {
            return dispatch(loadProvider())
        }).then(() => {
            onSubmit()
        })
    }

    render() {
        const {dispatch, form, cmd, activity, interventionPeriod, ...others} = this.props

        const chargeInputAddon = (
            <span>{i18n.currencyEnum.euro}</span>
        )

        const distanceInputAddon = (
            <span>km</span>
        )

        const distanceField = (field) => {
            const value = field.value && field.value / 1000

            function onChange(value) {
                field.onChange(value && value * 1000)
            }

            return {...field, value, onChange}
        }

        return (
            <div>
                <ul className={style.callOutChargeGroup}>
                    {cmd && cmd.callOutCharges && cmd.callOutCharges.slice(1).reverse().map((callOutCharge, index) => (
                        <li key={index}>
                            <a
                                href=''
                                className={style.remove}
                                onClick={(e) => form.callOutCharges.remove(e, callOutCharge)}>
                                <Icon icon='minus' size='xs' />
                            </a>
                            <p>
                                <span>{replace(i18n.distanceFromTo, {from: distance(callOutCharge.range.start).format('km'), to: distance(callOutCharge.range.end).format('km')})}</span>
                                <span> : {callOutCharge.charge.value} {i18n.currencyEnum.euro}</span>
                            </p>
                        </li>
                    ))}
                </ul>
                <form>
                    <Row>
                        <Col xs={6}>
                            <Input
                                type='text'
                                name='startRange'
                                placeholder={i18n.startRange}
                                addonAfter={distanceInputAddon}
                                {...integerField(distanceField(form.callOutCharges.range.start()))} />
                        </Col>
                        <Col xs={6}>
                            <Input
                                type='text'
                                name='endRange'
                                placeholder={i18n.endRange}
                                addonAfter={distanceInputAddon}
                                {...integerField(distanceField(form.callOutCharges.range.end()))} />
                        </Col>
                    </Row>
                    <Input
                        type='text'
                        name='charge'
                        placeholder={i18n.charge}
                        addonAfter={chargeInputAddon}
                        {...integerField(form.callOutCharges.charge.value())} />
                </form>
                <ButtonToolbar>
                    {form.callOutCharges.isValid() && (
                        <Button
                            bsStyle='link'
                            onClick={() => form.callOutCharges.add()}>
                            <Icon icon='plus' size='xs' />
                            <span>{i18n.add}</span>
                        </Button>
                    )}
                    {cmd && cmd.callOutCharges && cmd.callOutCharges.length > 1 && (
                        <Button
                            bsStyle='link'
                            onClick={() => form.callOutCharges.remove()}>
                            <Icon icon='minus' size='xs' />
                            <span>{i18n.remove}</span>
                        </Button>
                    )}
                </ButtonToolbar>
                <ButtonToolbar>
                    <Button
                        bsStyle='primary'
                        bsSize='large'
                        className={cx({disabled: !form.isValid()})}
                        onClick={() => form.validate() && this._sendDefineCmd() || dispatch(errorStatus(i18n.formInvalid))}>
                        {i18n.validate}
                    </Button>
                    {interventionPeriod.callOutCharges.length > 0 && (
                        <Button
                            bsStyle='danger'
                            bsSize='large'
                            onClick={() => this._sendRemoveCmd()}>
                            {i18n.remove}
                        </Button>
                    )}
                </ButtonToolbar>
            </div>
        )
    }
}

DefineRemoveCallOutChargesFromInterventionPeriodForm = connectForm({
    target: 'cmd',
    schema: DefineCallOutChargesForInterventionPeriodCmd.schema,
    action: DEFINE_CALL_OUT_CHARGES_FOR_INTERVENTION_PERIOD_CMD_UPDATED
})(DefineRemoveCallOutChargesFromInterventionPeriodForm)

DefineRemoveCallOutChargesFromInterventionPeriodForm = connect((state) => ({
    cmd: state.provider.defineCallOutChargesForInterventionPeriodCmd,
}))(DefineRemoveCallOutChargesFromInterventionPeriodForm)

export default DefineRemoveCallOutChargesFromInterventionPeriodForm


// WEBPACK FOOTER //
// ./lib/provider/components/DefineRemoveCallOutChargesFromInterventionPeriodForm.js